import { SeatConfig, GoldDirect } from "./seat_state_component";
import { PokerComponent } from "./poker_component";
import { BetMoveEffect } from "./bet_move_effect";
import { DealCardsEffect } from "./deal_cards_effect";
import { ColorSliderComponent } from "./colorslider_component";

const {ccclass, property} = cc._decorator;

//处理座位UI
@ccclass
export class SeatComponent extends cc.Component {

    @property(cc.Sprite)
    avatar:cc.Sprite = null;

    //0-红 1-绿 2-黄
    @property(ColorSliderComponent)
    countDown:ColorSliderComponent = null;

    @property(cc.Label)
    myName:cc.Label = null;

    operatorDes:cc.Sprite = null;

    @property(cc.Label)
    userGold:cc.Label = null;

    @property(cc.Node)
    smallPoker:cc.Node = null;

    @property(cc.Node)
    active:cc.Node = null;

    @property(cc.Label)
    serverID:cc.Label = null;

    @property(cc.Label)
    testDes:cc.Label = null;

    @property(cc.Node)
    mask:cc.Node = null;

    @property([PokerComponent])
    mHands:PokerComponent[] = [];

    @property(cc.Node)
    winner:cc.Node = null;

    @property([DealCardsEffect])
    twoSmallCards:DealCardsEffect[] = [];

    @property(BetMoveEffect)
    betMoveEffect:BetMoveEffect = null;

    @property(cc.Node)
    betEndNode:cc.Node = null;
    //金币适配控制
    @property(cc.Node)
    goldTarget:cc.Node = null;

    @property(cc.Label)
    goldNumb:cc.Label = null;

    @property(cc.Node)
    myGoldNode:cc.Node = null;

    @property(cc.Node)
    goldRoot:cc.Node = null;

    //操作显示
    @property(cc.Node)
    operatorNode:cc.Node = null;

    @property(cc.Node)
    animationNode:cc.Node = null;
    //动画 operator 
    @property(cc.Node)
    operatorAnim:cc.Node = null;
    //最大牌型
    @property(cc.Node)
    maxCardNode:cc.Node = null;

    @property([cc.Node])
    animationNodes:cc.Node[] = [];

    @property([cc.Node])
    smallCards:cc.Node[] = [];

    @property(cc.Node)
    winAnim:cc.Node = null;

    @property(cc.Node)
    patternNode:cc.Node = null;

    @property(cc.Node)
    allInNode:cc.Node = null;

    bubbleType:string = null;

    @property(cc.Node)
    gradesNode:cc.Node = null;

    @property(cc.Node)
    effectNode:cc.Node = null;

    setDes(str:string){
        this.serverID.string = str;
    }

    setTest(str:string){
        this.testDes.string = str;
    }

    showHands(isShow:boolean = false){
        for (let hand of this.mHands) {
           isShow ? hand.show():hand.hide();
        }
    }

    //牌桌状态
    seatState(isIdle:boolean){
        this.active.active = !isIdle;
    }

    //更新每个位置的适配
    updateSeatInfo(seatConfig:SeatConfig){
        this.smallPoker.position = seatConfig.smallCard;
        //MyGold
        this.myGoldNode.position = seatConfig.goldVec2;
        this.goldTarget.position = seatConfig.goldTarget;
        this.goldNumb.node.position = seatConfig.goldNumb;
    }

}
